import './src/css/cssLoader';

import { AppRegistry } from 'react-native';
import { name as appName } from './app.json';
import App from './App';

if (module.hot) {
  module.hot.accept();
}
AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  initialProps: {},
  rootTag: (global as any).document.getElementById('app-root'),
});
